const locale = {
    en: {
        search: {
            trigger: 'Search',
            submenu: {
                buy: 'Buy',
                rent: 'Rent',
                new_property: 'New Property',
                property_agent: 'Property Agent',
                find_all: 'Find All',
            },
        },
        investment: {
            trigger: 'Investment',
            submenu: {
                crowdfund: 'Crowdfund',
                marketplace: 'Marketplace',
            },
        },
        professional: {
            trigger: 'Professional Service',
        },
        other: {
            trigger: 'Others',
            submenu: {
                forum: 'Forum',
                blog: 'Blog',
                plan_and_pricing: 'Plan & Pricing',
                top_up_wallet: 'Top Up Wallet',
                change_language: 'Change Language',
            },
        },
        compro: {
            trigger: 'Our Profile',
            submenu: {
                about_us: 'About Us',
                hiw: 'How It Works',
                faq: 'FAQ',
            },
        },
        solution: {
            trigger: 'Advertise',
            submenu: {
                sell: 'Sell',
                rent: 'Rent',
                new_property: 'New Property',
                professional: 'Professional',
            },
        },
        login: 'Login',
        member: {
            submenu: {
                member_area: 'Member Area',
                professional_area: 'Professional Area',
                suggestion: 'Suggestion',
                logout: 'Logout',
            },
        },
        advicement_login_first: 'Please login first to submit advicement',
    },
    id: {
        search: {
            trigger: 'Cari',
            submenu: {
                buy: 'Beli',
                rent: 'Sewa',
                new_property: 'Properti Baru',
                property_agent: 'Agen Properti',
                find_all: 'Temukan Semua',
            },
        },
        investment: {
            trigger: 'Investasi',
            submenu: {
                crowdfund: 'Crowdfund',
                marketplace: 'Marketplace',
            },
        },
        professional: {
            trigger: 'Jasa Profesional',
        },
        other: {
            trigger: 'Lainnya',
            submenu: {
                forum: 'Forum',
                blog: 'Blog',
                plan_and_pricing: 'Paket & Harga',
                top_up_wallet: 'Top Up Wallet',
                change_language: 'Ganti Bahasa',
            },
        },
        compro: {
            trigger: 'Profil Kami',
            submenu: {
                about_us: 'Tentang Kami',
                hiw: 'Cara Kerja',
                faq: 'FAQ',
            },
        },
        solution: {
            trigger: 'Pasang Iklan',
            submenu: {
                sell: 'Jual',
                rent: 'Sewa',
                new_property: 'Properti Baru',
                professional: 'Profesional',
            },
        },
        login: 'Login',
        member: {
            submenu: {
                member_area: 'Area Member',
                professional_area: 'Area Profesional',
                suggestion: 'Kritik & Saran',
                logout: 'Logout',
            },
        },
        advicement_login_first: 'Mohon login terlebih dahulu sebelum mengirim saran',
    },
};

export default locale;
